import { useEffect, useState } from "react";
import { BellRing, WifiOff, X } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LangContext";

// Tells the teacher how many recordings arrived since the last visit, including those sent after a student came back online.
export const RecordingsNotice = () => {
  const { t, lang } = useLang();
  const tr = t.rec;
  const [news, setNews] = useState(null);

  useEffect(() => {
    api.get("/teacher/recordings/news").then((r) => setNews(r.data)).catch(() => setNews(null));
  }, []);

  const total = news?.total ?? 0;
  if (!total) return null;
  const offline = news?.offline ?? 0;
  const names = Array.isArray(news?.offline_students) ? news.offline_students : [];

  const dismiss = () => { setNews(null); api.post("/teacher/recordings/seen").catch(() => {}); };
  const show = () => {
    document.querySelector("[data-testid=teacher-recordings-section]")?.scrollIntoView({ behavior: "smooth" });
    dismiss();
  };

  return (
    <div className="mb-8 flex items-start gap-4 bg-white border-s-4 border-[#047857] border border-[#E5DCCB] p-5" role="status" data-testid="teacher-recordings-notice">
      <BellRing className="w-6 h-6 shrink-0 text-[#047857] mt-0.5" />
      <div className="flex-1 min-w-0 space-y-1">
        <p className="font-semibold" data-testid="teacher-recordings-notice-total">{tr.nNew(total)}</p>
        {offline > 0 && (
          <p className="text-sm text-stone-700 inline-flex items-start gap-1.5" data-testid="teacher-recordings-notice-offline">
            <WifiOff className="w-4 h-4 shrink-0 mt-0.5 text-amber-700" /> <span>{tr.nOffline(offline)}{names.length ? ` (${names.join(lang === "ar" ? "، " : ", ")})` : ""}</span>
          </p>
        )}
        <button onClick={show} data-testid="teacher-recordings-notice-show" className="mt-2 inline-flex rounded-full bg-[#047857] text-white px-5 py-2 text-sm font-semibold hover:bg-[#065F46] transition-colors">{tr.nShow}</button>
      </div>
      <button onClick={dismiss} aria-label={t.reader.close} data-testid="teacher-recordings-notice-dismiss" className="p-1.5 rounded-full hover:bg-black/5"><X className="w-5 h-5" /></button>
    </div>
  );
};
